// extracted by mini-css-extract-plugin
export default {"studycontainer":"Studies_studycontainer__4G1+T","tabstyle":"Studies_tabstyle__Z5A4m"};